export const checkRatingImpacted = (ratingImpact: string): boolean => {
  if (!ratingImpact) return false;
  if (ratingImpact === "R") return true;
  return false;
};
